// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    TAG_PAGE_LOADING() {
      return {
        isLoading: true,
        tagPage: action.tagPage
      };
    },
    TAG_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const tag = get(currentState, 'tagFeaturedFeed.tag');
      const supertags = get(currentState, 'supertags.supertags');
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        tag,
        'tagPage',
        supertags
      );
      return {
        isLoading: false,
        data: {},
        ads: adModelData
      };
    },
    TAG_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
